export default __webpack_public_path__ + "static/media/edit-icon.a40bae62.svg";